import { format, utcToZonedTime } from "date-fns-tz";
import type { Event } from "src/types";

import endpoints from "@/utils/endpoints";

const get = endpoints();

export const PRIVATE_EVENT_DESCRIPTION =
  "RingCentral Events is an online events platform where you can create engaging virtual events that connect people around the globe.";

export const PRIVATE_EVENT_IMAGE_URL =
  "https://hopin.com/assets/hopin-thumb-20ef10c85dda7c226361e82ad455e6c30b0a96cbbf83db569454f9e30a2dd32c.png";

export function getDefaultMetaDescription(
  name: string,
  timeStart: string,
  timeEnd: string,
  timezone: string
) {
  const startDate = utcToZonedTime(timeStart, timezone);
  const endDate = utcToZonedTime(timeEnd, timezone);

  const formattedStartDate = format(startDate, "MMMM d, yyyy");
  const formattedEndDate = format(endDate, "MMMM d, yyyy");

  const dateRange =
    formattedStartDate === formattedEndDate
      ? formattedStartDate
      : `${formattedStartDate} to ${formattedEndDate}`;

  return `Get tickets to ${name}, taking place ${dateRange}. RingCentral Events is your source for engaging events and experiences.`;
}

/**
 * This function takes in input an event object
 * a returns a event metadata data object taking
 * into a account the type of event (private, public).
 */
export function getEventMetadata(event: Event) {
  const {
    name = "RingCentral Events Canvas",
    short_description: shortDescription,
    slug,
    event_type,
    time_start: timeStart,
    time_end: timeEnd,
    standard_timezone: timezone,
  } = event;

  const isPrivateEvent = event_type === "private_event";

  const title = isPrivateEvent ? `${name} | RingCentral Events` : name;
  const pageUrl = get("HOPIN_ROOT") + get("EVENT_REGISTRATION_ROUTE")(slug);
  const imageUrl = isPrivateEvent
    ? PRIVATE_EVENT_IMAGE_URL
    : event.marketing?.image_url;

  const publicDescription =
    shortDescription ||
    getDefaultMetaDescription(name, timeStart, timeEnd, timezone);
  const description = isPrivateEvent
    ? PRIVATE_EVENT_DESCRIPTION
    : publicDescription;

  return {
    title,
    pageUrl,
    description,
    imageUrl,
  };
}
